import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import coverImg from "../../../../assets/images/cover_sm.jpg";
import coreMembers from "../../../../assets/static/coreMembers";
import { getVolunteers, loadVolunteers } from "../../../controller/reducer/ui";
import "./styles.css";

const AboutUs = () => {
  const volunteers = useSelector(getVolunteers);
  const dispatch = useDispatch();

  useEffect(() => {
    if (volunteers.length === 0) {
      dispatch(loadVolunteers());
    }
  }, [dispatch]);

  return (
    <Container className="p-4 bg-light " style={{ minHeight: "100vh" }}>
      <Helmet>
        <title>{`CR21 | About Us`}</title>
        <meta
          name="description"
          content={
            "Read about the portal, and find the team of co-founders and volunteers that are behind it"
          }
        />
      </Helmet>
      <h1 className="h1 font-weight-normal ">About Us</h1>
      <hr />
      <Row>
        <Col>
          <img
            className="img-about"
            src={coverImg}
            alt="cover photo"
            style={{
              // maxWidth: "90%",
              float: "left",
              margin: "20px",
            }}
          />
          <p className="font-weight-normal " style={{ display: "inline" }}>
            <br />
            This is a community-based pan-India Covid resources portal. The
            portal was built through the group efforts of 4 final year students
            of IIT (ISM) Dhanbad and volunteers.
            <br /> <br />
            The portal has provisions to help Covid-19 patients and their
            caretakers through various resources and measures, which you can
            find on this post and our portal.
            <br /> <br />
            We urge everyone to please come forward and help this portal become
            even more useful, by increasing its reach and letting your family
            and friends know about it. You can also help the community by adding
            any verified resources you might have, on our portal. Taking just 5
            mins of your time to do this shall help save countless lives.
            <br />
          </p>
        </Col>
      </Row>
      <p className="text-center m-4">
        <a
          href="https://facebook.com/cr21ml"
          target="_blank"
          className="fab fa-facebook-square fa-2x"
          style={{ color: "var(--primary)", cursor: "pointer" }}
        ></a>
        <a
          href="https://www.instagram.com/cr21ml"
          target="_blank"
          className="fab fa-instagram-square fa-2x ml-2 mr-2"
          style={{ color: "#E1306C", cursor: "pointer" }}
        ></a>
        <a
          href="https://twitter.com/cr21ml"
          target="_blank"
          className="fab fa-twitter-square fa-2x"
          style={{ color: "blue", cursor: "pointer" }}
        ></a>
      </p>
      <Row>
        <Col>
          <p className="h3 font-weight-normal">Core Members</p>
          <hr />
          <Row>
            {coreMembers.map((member, id) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={id}>
                <div className="our-team">
                  <div className="picture">
                    <img className="img-fluid" src={member.img} />
                  </div>
                  <div className="team-content">
                    <h3 className="name">{member.name}</h3>
                    <h4 className="title">{member.role}</h4>
                  </div>
                  <ul className="social">
                    {member.facebook && (
                      <li>
                        <a
                          href={member.facebook}
                          target="_blank"
                          className="fab fa-facebook"
                          aria-hidden="true"
                        ></a>
                      </li>
                    )}
                    {member.linkedin && (
                      <li>
                        <a
                          href={member.linkedin}
                          target="_blank"
                          className="fab fa-linkedin"
                          aria-hidden="true"
                        ></a>
                      </li>
                    )}
                    {member.github && (
                      <li>
                        <a
                          href={member.github}
                          target="_blank"
                          className="fab fa-github"
                          aria-hidden="true"
                        ></a>
                      </li>
                    )}
                    {member.portfolio && (
                      <li>
                        <a
                          href={member.portfolio}
                          target="_blank"
                          className="fas fa-globe"
                          aria-hidden="true"
                        ></a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            ))}
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="h3 font-weight-normal">Volunteers</p>
          <hr />
          <Row>
            {volunteers.length > 0 &&
              volunteers.map((member, id) => (
                <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={id}>
                  <div className="our-team">
                    <div className="picture">
                      {member.image && (
                        <img className="img-fluid" src={member.image} />
                      )}
                    </div>
                    <div className="team-content">
                      {member.name && <h3 className="name">{member.name}</h3>}
                      {member.role && <h4 className="title">{member.role}</h4>}
                    </div>
                    <ul className="social">
                      <li>
                        {member.facebook && (
                          <a
                            href={member.facebook}
                            target="_blank"
                            className="fab fa-facebook"
                            aria-hidden="true"
                          ></a>
                        )}
                      </li>
                      <li>
                        {member.linkedin && (
                          <a
                            href={member.linkedin}
                            target="_blank"
                            className="fab fa-linkedin"
                            aria-hidden="true"
                          ></a>
                        )}
                      </li>
                      <li>
                        {member.github && (
                          <a
                            href={member.github}
                            target="_blank"
                            className="fab fa-github"
                            aria-hidden="true"
                          ></a>
                        )}
                      </li>
                      <li>
                        {member.portfolio && (
                          <a
                            href={member.portfolio}
                            target="_blank"
                            className="fas fa-globe"
                            aria-hidden="true"
                          ></a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              ))}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default AboutUs;
